import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationsService } from '../api/organizations.service';
import { ORGANIZATIONS_KEYS } from './queryKeys';

export function useDeleteOrganization() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);
  const clear = useOrganizationStore((s) => s.clear);

  return useMutation({
    mutationFn: (id: string) => organizationsService.delete(id),
    onSuccess: (_data, deletedId) => {
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.all });
      queryClient.removeQueries({ queryKey: ORGANIZATIONS_KEYS.detail(deletedId, deletedId) });
      if (activeOrganizationId === deletedId) {
        clear();
      }
    },
  });
}
